import { Benefit } from '../types/insurance-report-api.types';

export const prepareLimitationData = (benefit: Benefit) => {
  const { period, periodUnit, limit } = benefit;

  if (!period || !periodUnit || !limit) {
    return '';
  }
  const periodText = period === 1 ? periodUnit : `${period} ${periodUnit}s`;

  const limitation = `${limit || ''} / ${periodText}`;
  const maxAge = benefit.ageMax ? `, max: ${benefit.ageMax}yr` : '';
  const minAge = benefit.ageMin ? `, min: ${benefit.ageMin}yr` : '';

  return limitation + minAge + maxAge;
};

export const prepareNotesData = (benefit: Benefit): string[] => {
  const { notes, deductibleApplies, waitingPeriod, coPay } = benefit;

  const items: string[] = [];

  if (deductibleApplies) {
    items.push(`Deductible applies: ${deductibleApplies}`);
  }
  if (waitingPeriod) {
    items.push(`Waiting period: ${waitingPeriod}`);
  }
  if (coPay) {
    items.push(`Co Pay: ${coPay}`);
  }
  if ((notes || []).length) {
    const formattedNotes = convertNotesDataToLowerCase(notes);
    items.push(...formattedNotes);
  }

  return items;
};

export const convertNotesDataToLowerCase = (notes: string[]) => {
  //This pattern is to make sure the CDT codes will remain in uppercase while converting rest of the string to lowercase
  const pattern = /\b[dD][0-9]{4}\b/g;

  return notes.map((str) => str.toLowerCase().replace(pattern, (match) => match.toUpperCase()));
};

export const prepareTitleForLimitationColumn = (limitation: string, notes: string) => {
  if (notes && notes.length > 0) {
    return (limitation || 'N/A') + '*';
  }
  return limitation;
};

export const prepareServiceDateColumn = (serviceDates: string[]) => {
  if (!serviceDates || serviceDates.length === 0) {
    return { title: '', hoverText: [] };
  }
  if (serviceDates.length === 1) {
    return { title: serviceDates[0], hoverText: [] };
  } else {
    return { title: serviceDates[0] + '*', hoverText: serviceDates.slice(1) };
  }
};
